import { render, staticRenderFns } from "./WoundCreate.vue?vue&type=template&id=6c6274e8"
import script from "./WoundCreate.vue?vue&type=script&lang=ts"
export * from "./WoundCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports